var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHunter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 19.1714H7.42188L16.5647 5.22852H25.2504L16.1076 19.1714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4426 5H25.675L16.2324 19.4H7L16.4426 5ZM16.6895 5.45714L7.84643 18.9428H15.9855L24.8285 5.45714H16.6895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 31.9716H7.42188L16.5647 18.0288H25.2504L16.1076 31.9716Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4426 17.7998H25.675L16.2324 32.1998H7L16.4426 17.7998ZM16.6895 18.2569L7.84643 31.7426H15.9855L24.8285 18.2569H16.6895Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 44.7714H7.42188L16.5647 30.8286H25.2504L16.1076 44.7714Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4426 30.6001H25.675L16.2324 45.0001H7L16.4426 30.6001ZM16.6895 31.0572L7.84643 44.5429H15.9855L24.8285 31.0572H16.6895Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8514 19.1714H43.5371L34.3943 5.22852H25.7086L34.8514 19.1714Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5183 5H25.286L34.7286 19.4H43.9609L34.5183 5ZM34.2714 5.45714L43.1145 18.9428H34.9755L26.1324 5.45714H34.2714Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8514 31.9716H43.5371L34.3943 18.0288H25.7086L34.8514 31.9716Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5183 17.7998H25.286L34.7286 32.1998H43.9609L34.5183 17.7998ZM34.2714 18.2569L43.1145 31.7426H34.9755L26.1324 18.2569H34.2714Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8514 44.7714H43.5371L34.3943 30.8286H25.7086L34.8514 44.7714Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5183 30.6001H25.286L34.7286 45.0001H43.9609L34.5183 30.6001ZM34.2714 31.0572L43.1145 44.5429H34.9755L26.1324 31.0572H34.2714Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunter);
export default __webpack_public_path__ + "static/media/hunter.75eb006c0efacebc6b354e1405c0fa59.svg";
export { ForwardRef as ReactComponent };